import React from 'react';

import Modal from '@amzn/meridian/modal';
import {
  setIsTaskModalOpen,
  setSelectedTaskTableRow,
} from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';
import { useAppDispatch, useAppSelector } from 'src/store/store';

import TaskModalContent from './taskModalContent/taskModalContent';

// **** Components **** //

/**
 * Default component
 */
const TaskModal = () => {
  const dispatch = useAppDispatch();
  const { isTaskModalOpen, selectedTaskTableRow } = useAppSelector((state) => state.taskConfigPage);

  const onCancel = () => {
    dispatch(setIsTaskModalOpen(false));
    dispatch(setSelectedTaskTableRow(null));
  };

  return (
    <Modal
      title={selectedTaskTableRow ? 'Edit Task' : 'Add New Task'}
      open={isTaskModalOpen}
      onClose={onCancel}
      closeLabel="Close"
      aria-describedby="modal-description"
      width="700px"
      scrollContainer="modal"
    >
      <TaskModalContent />
    </Modal>
  );
};

// **** Export **** //

export default TaskModal;
